
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gBT_CiB3YvchZVvOcpJv_BVbNmPDZbbaITa3RW4O0gPIMeta } from "/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexXmg_fwwcnrQs8MUq2NlLizxU_45g0BV08UJVrVm_HHp_4Meta } from "/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchHqBQMLLcv6vy7FjUXM2lJ_45HQhFDUcxPMKCWyym1ZzK0Meta } from "/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexiYoZr_UY71q40dLsF3Fct34GhsUsEiY8zWjuKQTV0yIMeta } from "/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93FfImkjUJvhig9UA86k8rsYYn1lu7mErmra5569G3LCsMeta } from "/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexHuR9tO1yAD_45qclCVO88sA39r3qN1VoeLogO_sZw3tM0Meta } from "/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Ef9W_JZS9utTBExyLS9veir1Sm4pD2qLEw5nF1o_acYMeta } from "/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indextjQkjn1kRoFGHphde5DV2DxjbEDUb_45mhaYc8xbQ1HN4Meta } from "/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93H_45S56oeek1l9ZA7bF0cuFVKzWMC_XKx6yDXxo6FtrNkMeta } from "/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexD_SrBOMGxy4AGFd8XK2z2sKnv_Js9_tRTAMACYP_yzcMeta } from "/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexFqBWzE7mzfT2RzWt3nH4rYFSfKOyMrHpoGNaBMZb9jgMeta } from "/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexHuR9tO1yAD_45qclCVO88sA39r3qN1VoeLogO_sZw3tM0Meta || {},
    component: () => import("/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indextjQkjn1kRoFGHphde5DV2DxjbEDUb_45mhaYc8xbQ1HN4Meta || {},
    component: () => import("/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexD_SrBOMGxy4AGFd8XK2z2sKnv_Js9_tRTAMACYP_yzcMeta || {},
    component: () => import("/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexFqBWzE7mzfT2RzWt3nH4rYFSfKOyMrHpoGNaBMZb9jgMeta || {},
    component: () => import("/codebuild/output/src865193157/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]